<template>
	<div id="strategy_list">
		<div class="strategy-list">
			<div class="strategy-item" v-for="(item,index) in strategyData" :key="index">
				<div class="single-img" v-if="item.imgType == 0 || item.imgType == 1">
					<div class="left-cover">
						<div class="cover-img">
							<img :src="item.imgUrl" v-if="item.imgUrl" alt="">
							<img src="../../assets/img/live/no_play.png" v-else alt="">
						</div>
						<!-- <img src="../../assets/img/bull_class/fufei_2x.png" alt="" class="fu_fei" v-if="item.isFree == 1"> -->
					</div>
					<div class="right-context">
						<div class="context-top" @click="getStrategyDetail(item)">{{ item.title || defaultTitle }}</div>
						<div class="context-middle"></div>
						<div class="context-bottom">
							<div class="user-info">
								<div class="logo">
									<img :src="item.usPhotoFileid" alt="">
								</div>
								<div class="info">
									<div class="username">
										{{ item.analystName }}
									</div>
									<div class="send-time">
										{{ item.createTime }}
									</div>
								</div>
							</div>
							<div class="user-operation">
								<div class="operation-item" @click="strategyForward(item)">
									<img src="../../assets/img/bull_strategy/转发@2x.png" alt="">
									<span>{{ item.commentNum }}</span>
								</div>
								<span>|</span>
								<div class="operation-item" @click="strategyComment(item)">
									<img src="../../assets/img/bull_strategy/评论@2x.png" alt="">
									<span>{{ item.shareNum }}</span>
								</div>
								<span>|</span>
								<div class="operation-item" @click="strategyLike(item)">
									<img src="../../assets/img/bull_strategy/点赞@2x.png" alt="">
									<span>{{ item.likeNum }}</span>
								</div>
							</div>
						</div>
					</div>
				</div>
				
				<div class="multi-img" v-if="item.imgType == 2">
					<div class="context-top">{{ item.title || defaultTitle }}</div>
					<div class="context-middle">
						<div class="cover-item" v-for="(item,index) in item.imgList"   :style="{backgroundImage: 'url(' + item + ')', backgroundSize:'100% 100%', backgroundRepeat: 'no-repeat'}">
							<!-- <img src="../../assets/img/bull_class/fufei_2x.png" alt="" class="fu_fei">
							<img src="https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg" alt=""> -->
						</div>
					</div>
					<div class="context-bottom">
						<div class="user-info">
							<div class="logo">
								<img :src="item.usPhotoFileid" alt="">
							</div>
							<div class="info">
								<div class="username">
									{{ item.analystName }}
								</div>
								<div class="send-time">
									{{ item.createTime }}
								</div>
							</div>
						</div>
						<div class="user-operation">
							<div class="operation-item" @click="strategyForward(item)">
								<img src="../../assets/img/bull_strategy/转发@2x.png" alt="">
								<span>{{ item.commentNum }}</span>
							</div>
							<span>|</span>
							<div class="operation-item" @click="strategyComment(item)">
								<img src="../../assets/img/bull_strategy/评论@2x.png" alt="">
								<span>{{ item.shareNum }}</span>
							</div>
							<span>|</span>
							<div class="operation-item" @click="strategyLike(item)">
								<img src="../../assets/img/bull_strategy/点赞@2x.png" alt="">
								<span>{{ item.likeNum }}</span>
							</div>
						</div>
					</div>
				</div>
				
				<div class="zero-img" v-if="item.imgType == 3">
					<div class="context-top">{{ item.title || defaultTitle }}</div>
					<div class="context-middle">{{  }}</div>
					<div class="context-bottom">
						<div class="user-info">
							<div class="logo">
								<img :src="item.usPhotoFileid" alt="">
							</div>
							<div class="info">
								<div class="username">
									{{ item.analystName }}
								</div>
								<div class="send-time">
									{{ item.createTime }}
								</div>
							</div>
						</div>
						<div class="user-operation">
							<div class="operation-item" @click="strategyForward(item)">
								<img src="../../assets/img/bull_strategy/转发@2x.png" alt="">
								<span>{{ item.commentNum }}</span>
							</div>
							<span>|</span>
							<div class="operation-item" @click="strategyComment(item)">
								<img src="../../assets/img/bull_strategy/评论@2x.png" alt="">
								<span>{{ item.shareNum }}</span>
							</div>
							<span>|</span>
							<div class="operation-item" @click="strategyLike(item)">
								<img src="../../assets/img/bull_strategy/点赞@2x.png" alt="">
								<span>{{ item.likeNum }}</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name:'strategyList',
		data(){
			return {
				defaultTitle:'暂无标题',
				page:{
					"page-size":10,
					"total":0,
					"layout":"prev, pager, next",
				}
			}
		},
		props:{
			strategyData:{
				type:Array,
			}
		},
		mounted() {
			
		},
		methods:{
			getfirstContentList(){
				//+----------------构建请求参数------------------
				let data = {
					applicationType:this.store.state.applicationType,
				};
				
				//+-----获取首页直播预告、牛策略、牛人课列表------
				this.apiServer.live.getfirstContentList()
				.then(res => {
					if(res.data.code == 200){
						this.strategyList = res.data.data.niuContentList;
					}
				})
				.catch(res => {
					this.$message.error('操作异常');
				});
			},
			getStrategyDetail(item){
				// console.log('进入牛策略详情',item)
				this.$router.push({name:'strategyDetail',query:{article_id:item.id,article_type:item.contentType}});
			},
			strategyForward(){
				this.$message('点击了转发');
			},
			strategyComment(){
				this.$message('点击了评论');
			},
			strategyLike(){
				this.$message('点击了点赞');
			},
		}
	}
</script>

<style scoped>
	#strategy_list{
		
	}
	
	.sub_size {
		height: 14.5rem;
		
		/* margin: 0 auto; */
		padding: 0 7px;
		border-top-left-radius: 5px;
		border-top-right-radius: 5px;
		background-size: 100% 100% !important;
		min-width: 50%;
	}
	.sub_001 {
		background: #FFFFFF;
		border-bottom-left-radius: 5px;
		border-bottom-right-radius: 5px;
		padding: 0 7px;
	}
	
	.fu_fei {
		display: block;
		float: right;
		width: 20%;
	}
	img {
		display: block;
		margin: auto;
	}
	
	.sub_001 p:nth-child(1) {
		color: #222222;
		font-size: 1.25rem;
		padding-top: 10px;
		overflow: hidden;
		/* height: 60px; */
		text-align: left;
		
		font-family: PingFangSC-Semibold, PingFang SC;
		font-weight: 600;
		color: #222222;
		line-height: 1.75rem;
	}
	.sub_001 p:nth-child(2) {
		color: #666666;
		padding-bottom: 1.25rem;
		
		
		font-size: 18px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #666666;
		line-height: 25px;
	}
	
	
	
	/* 新的改动 */
	.strategy-list{
		background: #FFFFFF;
	}
	.strategy-item{
		cursor: pointer;
		border-bottom: 1px solid gray;
		/* margin-left: 60px; */
		margin-right: 60px;
		padding: 10px;
		border-radius: 8px;
	}
	
	.strategy-item img{
		border-radius: 8px;
	}
	
	.strategy-item .single-img{
		display: flex;
		justify-content: space-around;
	}
	
	.strategy-item .multi-img{
	}
	
	.strategy-item .zero-img{
	}
	
	.strategy-item .left-cover{
		/* margin-top: 42px;
		margin-left: 60px; */
	}
	.left-cover .cover-img img{
		width: 340px;
		height: 207px;
	}
	
	.strategy-item .right-context{
		width: 70%;
		margin-left: 10px;
	}
	
	.context-top{
		height: 33px;
		font-size: 24px;
		font-family: PingFangSC-Semibold, PingFang SC;
		font-weight: 600;
		color: #222222;
		line-height: 33px;
		overflow: hidden;
	}
	
	.context-middle{
		height: 114px;
	}
	
	.context-bottom{
		display: flex;
		justify-content: space-between;
	}
	
	.context-bottom .user-info{
		display: flex;
		align-items: center;
	}
	.context-bottom .user-info .logo{
		
	}
	.context-bottom .user-info img{
		width: 60px;
	}
	.user-info .info{
		margin-left: 17px;
		font-size: 18px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #444444;
		line-height: 25px;
	}
	
	.context-bottom .user-operation{
		display: flex;
		align-items: center;
		justify-content: space-around;
		margin-top: 20px;
	}

	.user-operation .operation-item{
		display: flex;
		align-items: center;
	}
	.user-operation .operation-item img{
		max-width: 30%;
	}

	.context-middle{
		display: flex;
		justify-content: space-between;
	}
	.context-middle .cover-item{
		width: 30%;
		min-height: 12.5rem;
	}

</style>



// WEBPACK FOOTER //
// src/components/common/strategy_list.vue